import type { Requests } from "../common/request.common";
import type { AssociatePresenceResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const associatePresence = {
    record(data: typeof Requests.AssociatePresence.Record.Input) {
        return post<typeof data, AssociatePresenceResponseTypes.Record>(
            `/associate-presence/record`,
            data,
        );
    },
    create(data: typeof Requests.AssociatePresence.Create.Input) {
        return post<typeof data>(`/associate-presence/create`, data);
    },
    obtain(id: string) {
        return get<AssociatePresenceResponseTypes.Obtain>(`/associate-presence/obtain/${id}`);
    },
};
